module.exports = __webpack_public_path__ + "static/media/arrow-right.c2328ad4.svg";